<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout row wrap justify-center>
          <!-- MODULE PHOTO ORDER ADMIN SECTION -->
          <v-flex
            class="py-0 pb-1 pt-0 px-1"
            xs12
            v-if="
              ($store.state.storeClient.client.modules.modulePhotoOrder.active &&
                $store.state.storeAuth.userProfile.isSuperAdmin &&
                $store.state.storeAuth.userProfile.client ==
                  $store.state.storeClient.client.basicSettings.name) || $store.state.storeAuth.userProfile.isSuperStoreAdmin
            "
          >
            <v-card
              :class="
                getTheme() == 'dark'
                  ? 'outlined elevation-0'
                  : 'flat elevation-0'
              "
              :style="
                getTheme() == 'dark'
                  ? 'border: 1px solid darkgray'
                  : 'border-bottom: 1px solid lightgray'
              "
            >
              <v-card-title
                :style="
                  getTheme() == 'dark'
                    ? 'background-color: #505050'
                    : 'background-color: white; border-bottom: 1px solid lightgray'
                "
                :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
                class="title font-weight-regular"
              >
                <v-icon
                  :class="
                    getTheme() == 'dark' ? 'white--text' : 'primary--text'
                  "
                  class="mr-3"
                  medium
                >mdi-image-multiple</v-icon>
                {{ $t("settingsSubMenuModulePhotoOrderTitle") }}
              </v-card-title>
              <v-card-actions
                class="d-flex flex-wrap align-stretch"
                :class="
                  getTheme() == 'dark' ? '#505050--text' : '#505050--text'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'background-color: whitesmoke'
                    : 'background-color: white'
                "
              >
                <!-- BASIC SETTINGS -->
                <home-menu-admin-btn
                  :allow="($store.state.storeClient.client.modules.modulePhotoOrder
                      .active &&
                      $store.state.storeAuth.userProfile.isSuperAdmin &&
                      $store.state.storeAuth.userProfile.client ==
                        $store.state.storeClient.client.basicSettings.name) || $store.state.storeAuth.userProfile.isSuperStoreAdmin"
                  path="/settingsPhotoOrderBasic"
                  icon="mdi-comment-edit"
                  :title="$t('dashboardCardSuperAdminBasicSettings')"
                ></home-menu-admin-btn>
                <!-- SETTINGS IMAGE SIZE -->
                <home-menu-admin-btn
                  :allow="($store.state.storeClient.client.modules.modulePhotoOrder
                      .active &&
                      $store.state.storeAuth.userProfile.isSuperAdmin &&
                      $store.state.storeAuth.userProfile.client ==
                        $store.state.storeClient.client.basicSettings.name) || $store.state.storeAuth.userProfile.isSuperStoreAdmin"
                  path="/settingsImageSize"
                  icon="mdi-image-size-select-large"
                  :title="$t('dashboardCardSuperAdminImageSizes')"
                ></home-menu-admin-btn>
                <!-- SETTINGS PAPER TYPES -->
                <home-menu-admin-btn
                  :allow="($store.state.storeClient.client.modules.modulePhotoOrder
                      .active &&
                      $store.state.storeAuth.userProfile.isSuperAdmin &&
                      $store.state.storeAuth.userProfile.client ==
                        $store.state.storeClient.client.basicSettings.name) || $store.state.storeAuth.userProfile.isSuperStoreAdmin"
                  path="/settingsPaperType"
                  icon="mdi-paper-roll-outline"
                  :title="$t('dashboardCardSuperAdminPaperType')"
                ></home-menu-admin-btn>
                <!-- SETTINGS IMAGE DISCOUNTS -->
                <home-menu-admin-btn
                  :allow="($store.state.storeClient.client.modules.modulePhotoOrder
                      .active &&
                      $store.state.storeAuth.userProfile.isSuperAdmin &&
                      $store.state.storeAuth.userProfile.client ==
                        $store.state.storeClient.client.basicSettings.name) || $store.state.storeAuth.userProfile.isSuperStoreAdmin"
                  path="/settingsImageDiscounts"
                  icon="mdi-sale"
                  :title="$t('dashboardCardSuperAdminImageDiscounts')"
                ></home-menu-admin-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
          <simple-navigation-button
            left
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            @clicked="$router.push({ name: 'settingsSubMenu' })"
          ></simple-navigation-button>
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import AppNavigation from "@/views/AppNavigation";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";
import HomeMenuAdminBtn from "@/components/HomeMenuAdminBtn";

export default {
  name: "settingsSubMenuModulePhotoOrder",
  components: {
    AppNavigation,
    SimpleNavigationButton,
    HomeMenuAdminBtn
  }
};
</script>
<style scoped>
.item {
  margin: 5px;
  padding: 5px;
  width: 100px;
  text-align: center;
}
</style>
